// Tests: src/app/migrations/migrations.spec.ts
import { MigrationDefinition } from './migration.types';

/**
 * Migration: V8 → V9
 *
 * Korrektur der Staunässe-Punkttypen, die vor Commit 163c0529 vertauscht waren
 * (12↔13 und 112↔113). Alte Datensätze tragen noch die falschen `type`-Strings,
 * deren SVG-Dateien inzwischen umbenannt wurden → 404 beim Laden.
 *
 * Mapping (Upgrade):
 *   '12_SW_geringer'     -> '12_SW_stärker'
 *   '13_SW_stärker'      -> '13_SW_geringer'
 *   '112_SW_geringer_2'  -> '112_SW_stärker_2'
 *   '113_SW_stärker_2'   -> '113_SW_geringer_2'
 */
const TYPE_FIX_FORWARD: Record<string, string> = {
  '12_SW_geringer': '12_SW_stärker',
  '13_SW_stärker': '13_SW_geringer',
  '112_SW_geringer_2': '112_SW_stärker_2',
  '113_SW_stärker_2': '113_SW_geringer_2',
};

const TYPE_FIX_BACKWARD: Record<string, string> = Object.fromEntries(
  Object.entries(TYPE_FIX_FORWARD).map(([k, v]) => [v, k])
);

export const migrationV8ToV9: MigrationDefinition = {
  fromVersion: 8,
  toVersion: 9,

  upgrade(doc: any): any {
    if (typeof doc.type === 'string' && TYPE_FIX_FORWARD[doc.type]) {
      doc.type = TYPE_FIX_FORWARD[doc.type];
    }
    doc.version = 9;
    return doc;
  },

  downgrade(doc: any): any {
    if (typeof doc.type === 'string' && TYPE_FIX_BACKWARD[doc.type]) {
      doc.type = TYPE_FIX_BACKWARD[doc.type];
    }
    doc.version = 8;
    return doc;
  },
};
